import { render, staticRenderFns } from "./server.vue?vue&type=template&id=aa0841c0&scoped=true&"
import script from "./server.vue?vue&type=script&lang=js&"
export * from "./server.vue?vue&type=script&lang=js&"
import style0 from "./server.vue?vue&type=style&index=0&id=aa0841c0&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "aa0841c0",
  null
  
)

export default component.exports